var React = require('react');

function IconInstagramInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.5 18a4.502 4.502 0 01-4.502-4.5A4.501 4.501 0 0118 13.497v.003a4.504 4.504 0 01-4.5 4.5m8.25-13.95a1.5 1.5 0 10.003 3 1.5 1.5 0 00-.003-3M13.5 6a7.501 7.501 0 107.5 7.5A7.508 7.508 0 0013.5 6m6 21h-12A7.508 7.508 0 010 19.5v-12A7.508 7.508 0 017.5 0h12A7.508 7.508 0 0127 7.5v12a7.508 7.508 0 01-7.5 7.5","fill":"#2777b8","fillRule":"evenodd"}));
}

IconInstagramInline.defaultProps = {"viewBox":"0 0 27 27"};

module.exports = IconInstagramInline;

IconInstagramInline.default = IconInstagramInline;
